module.exports = __webpack_public_path__ + "static/media/FAQHero.8e24136e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/FAQ/FAQHero.png
// module id = 628
// module chunks = 0